module.exports = __webpack_public_path__ + "img/foto_12.55c3b9ff.png";